export default "__VITE_ASSET__D1OmJv7b__"